import Title from "../../common/title/title";
import SelfEmployedFormPageRegistrationDataItem from "./self-employed-page-registration-data-item/self-employed-page-registration-data-item";
import "./self-employed-page-registration-data.sass";

const SelfEmployedFormPageRegistrationData = () => {
  return (
    <div className="self-employed-page-registration-data">
      <Title>Данные необходимые для регистрации</Title>

      <div className="self-employed-page-registration-data__list">
        <SelfEmployedFormPageRegistrationDataItem>
          ФИО (полностью)
        </SelfEmployedFormPageRegistrationDataItem>

        <SelfEmployedFormPageRegistrationDataItem>
          Паспортные данные
        </SelfEmployedFormPageRegistrationDataItem>

        <SelfEmployedFormPageRegistrationDataItem>
          ИНН (физ. лица, 12 цифр)
        </SelfEmployedFormPageRegistrationDataItem>

        <SelfEmployedFormPageRegistrationDataItem>
          Скан первой страницы паспорта
        </SelfEmployedFormPageRegistrationDataItem>

        <SelfEmployedFormPageRegistrationDataItem>
          Скан страницы паспорта с пропиской
        </SelfEmployedFormPageRegistrationDataItem>

        <SelfEmployedFormPageRegistrationDataItem>
          Банковские реквизиты
        </SelfEmployedFormPageRegistrationDataItem>

        <SelfEmployedFormPageRegistrationDataItem>
          Адрес проживания
        </SelfEmployedFormPageRegistrationDataItem>

        <SelfEmployedFormPageRegistrationDataItem>
          Контактные данные
        </SelfEmployedFormPageRegistrationDataItem>
      </div>
    </div>
  );
};

export default SelfEmployedFormPageRegistrationData;
